import shop from '../../api/orderTransaction';
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';
import { request_list, update_detail, create_detail, remove_detail } from '@/commons/hpod';
import configs from '@/configs';
import _ from "lodash";
import Vue from 'vue';
const endpoint = 'order_transactions'

// initial state
const state = {
    loading: false,
    edited: false,
    all: {},
    orderCodes: [],
    transCodes: [],
    selected: {},
    listOfDay: {}
};

// getters
const getters = {};

// actions
const actions = {
    getList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint, data => {
            commit('setList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getListOfDay({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint, data => {
            commit('setStoreManagerListOfDay', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getOrderTransactionList({ commit }, param) {
        shop.getOrderTransactionList(data => {
            commit('setOrderTransactionList', data);
        }, Vue.http, param, this.state.authentication.token);
    },
    putOrderTransaction({ commit, dispatch }, param) {
        commit('setEdited', {edited: false});
        shop.putOrderTransaction(item => {
            if(item.status == 204) {
                sendErrorNotice('Mã vận đơn đã tồn tại.')
            }
            else{
                sendSuccessNotice('Đã thêm mới mã vận đơn.')
                shop.getOrderTransactionList(data => {
                    commit('setOrderTransactionList', data);
                    if(param.PackageType == 1) {
                        dispatch("deposit/getDetail", param.OrderID, {root:true});
                    }
                    else {
                        dispatch("main_order/getOrderDetail", param.OrderID, {root:true});
                    }
                }, Vue.http, { order_id: param.OrderID, package_type: param.PackageType }, this.state.authentication.token);
            }
        }, Vue.http, param, this.state.authentication.token);
    },
    deleteOrderTransaction({ commit, dispatch }, param) {
        const list_param = param.param;
        delete param.param;
        commit('setEdited', {edited: false});
        shop.deleteOrderTransaction(data => {
            commit('deleteOrderTransactionList', {type: param.type, idx: param.idx});
            sendSuccessNotice('Đã xóa mã vận đơn.')
            if(list_param) {
                if(param.type == "transaction") {
                    dispatch('getList', list_param);
                }
                else {
                    dispatch('ordercn/getList', list_param, {root: true});
                }
            }
        }, Vue.http, param, this.state.authentication.token);
    },
    postOrderTransaction({ commit, dispatch }, param) {
        commit('setEdited', {edited: false});
        let packageId = param.PackageId;
        delete param.PackageId;
        let filterTransaction = param.FilterTransaction;
        delete param.FilterTransaction;
        shop.postOrderTransaction(data => {
            commit('setEdited', {edited: true});
            if(data.status == 204) {
                sendErrorNotice('Mã vận đơn đã tồn tại.')
                shop.getOrderTransactionList(data => {
                    commit('setOrderTransactionList', data);
                    if(param.PackageType == 1) {
                        dispatch("deposit/getDetail", param.OrderID, {root:true});
                    }
                    else {
                        dispatch("main_order/getOrderDetail", param.OrderID, {root:true});
                    }
                }, Vue.http, { order_id: param.OrderID, package_type: param.PackageType }, this.state.authentication.token);
            }
            else {
                sendSuccessNotice('Cập nhật dữ liệu thành công.')
                if(param.PackageType == 1) {
                    dispatch("deposit/getDetail", param.OrderID, {root:true});
                }
                else {
                    if(packageId){
                        dispatch("bigPackageVn/getDetail", {'packageId': packageId, 'trancode': filterTransaction ? filterTransaction : ''}, {root:true});
                    }
                    else {
                        dispatch("main_order/getOrderDetail", param.OrderID, {root:true});
                    }
                }
            }
        }, Vue.http, param, this.state.authentication.token);
    },
    setDetail({ dispatch, commit }, {data, id, param, order_id}) {
        if(id > 0) {
            data.ModifiedBy = this.state.authentication.user.username;
            update_detail(endpoint, res => {
                if (res.data.status === 'fail') {
                    sendErrorNotice('Không thể cập nhật mã vận đơn.')
                }
                else {
                    sendSuccessNotice('Cập nhật mã vận đơn thành công.')
                    if (data.RequestAction == 'DEL') {
                        commit("removeItemFromListOfDay", id);
                        refreshResource();
                    }
                    
                    if (data.TransactionView == 'order_detail' || data.TransactionView == 'store_tq') {
                        if(data.PackageType == 1) {
                            dispatch("deposit/getDetail", data.OrderID || order_id, {root:true});
                            dispatch("changedHistories/getList", {'orderId': data.OrderID  || order_id, 'orderType': configs.ORDER_TYPE.deposit}, {root:true});
                        }
                        else {
                            dispatch("main_order/getOrderDetail", data.OrderID  || order_id, {root:true});
                        }
                    }
                    if (data.TransactionView == 'tran_list' || !param) {
                        refreshResource();
                    }
                    else if(param) {
                        dispatch('getList', param);
                    }
                }
            }, Vue.http, data, id, this.state.authentication.token);
        }
        else {
            data.CreatedBy = this.state.authentication.user.username;
            delete data.ID;
            create_detail(endpoint, res => {
                if(res.status == 204) {
                    sendErrorNotice('Mã vận đơn đã tồn tại.')                    
                }
                else if (res.data.status === 'fail') {
                    sendErrorNotice('Không thể thêm mới mã vận đơn.')
                }
                else {
                    sendSuccessNotice('Thêm mới mã vận đơn thành công.');
                    if (data.TransactionView == 'store_cn_popup') {
                        dispatch('getListOfDay', param);
                    }
                    if (data.TransactionView == 'order_detail') {
                        dispatch('getList', param);
                        if(data.PackageType == 1) {
                            dispatch("deposit/getDetail", data.OrderID, {root:true});
                            dispatch("changedHistories/getList", {'orderId': data.OrderID, 'orderType': configs.ORDER_TYPE.deposit}, {root:true});
                        }
                        else {
                            dispatch("main_order/getOrderDetail", data.OrderID, {root:true});
                        }
                    }
                }
            }, Vue.http, data, this.state.authentication.token);
        }
    },
    updateMultiple({ commit }, param) {
        commit("setLoading", { loading: true });
        shop.updateMultiple(res => {
            commit("setLoading", { loading: false });
            if(res.data.status === 'fail'){
                sendErrorNotice('Không thể cập nhật mã vận đơn.')
            }
            else {
                sendSuccessNotice('Cập nhật mã vận đơn thành công.')
            }
        }, Vue.http, this.state.authentication.token, param);
    },
    removeDetail({ commit, dispatch }, {id, param, order_id}) {
        commit("setLoading", { loading: true });
        remove_detail(endpoint, res => {
            if (res.data.status === false) {
                sendErrorNotice('Không thể xóa mã vận đơn.')
            }
            else {
                sendSuccessNotice('Đã xóa mã vận đơn thành công.')
                commit("removeItemFromListOfDay", id);
                if (param) {
                    dispatch('getList', param);
                }
                else {
                    refreshResource();
                }
                if (order_id) {
                    if(data.PackageType == 1) {
                        dispatch("deposit/getDetail", order_id, {root:true});
                        dispatch("changedHistories/getList", {'orderId': order_id, 'orderType': configs.ORDER_TYPE.deposit}, {root:true});
                    }
                    else {
                        dispatch("main_order/getOrderDetail", order_id, {root:true});
                    }
                }
            }
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    }
};

// mutations
const mutations = {
    setList(state, data) {
        state.all = data;
    },
    setOrderTransactionList(state, res) {
        state.orderCodes = res.data.order_codes;
        state.transCodes = res.data.order_transactions;
    },
    updateOrderTransactionList(state, {type, res}) {
        if(type === "order_code"){
            state.orderCodes.push(res.data);
        }
        else {
            state.transCodes.push(res.data);
        }
        state.edited = true;
    },
    deleteOrderTransactionList(state, {type, idx}) {
        if(type === "order_code"){
            state.orderCodes.splice(idx, 1);
        }
        else {
            state.transCodes.splice(idx, 1);
        }
        state.edited = true;
    },
    setEdited(state, { edited }) {
        state.edited = edited;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
    setDetail(state, item) {
        state.selected = item.data;
    },
    removeItemFromListOfDay(state, id){
        _.remove(state.listOfDay.data, {
            'ID': id
        });
        state.listOfDay.total -=1;
    },
    setStoreManagerListOfDay(state, data) {
        state.listOfDay = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
